import { FC, Fragment } from 'react';
import { entries, groupBy } from 'lodash';

import { BDTO, useGetTherapistScheduleSlots } from '@helpful/network';
import { Form, useFormControl, Loading } from '@wearehelpful/ui-kit';
import { useDate, useTranslation } from '@wearehelpful/ui-localization';

import { Container, Column, Cell, Title, Heading } from './ScheduleSlot.style';

interface ScheduleSlotProps {
  id: string;
}

export const ScheduleSlot: FC<ScheduleSlotProps> = ({ id }) => {
  const [date] = useFormControl<string>({
    name: 'date',
    watch: true,
  });

  const { t } = useTranslation();

  const { tz, format } = useDate();

  const { data, isFetching } = useGetTherapistScheduleSlots(
    id,
    {
      date,
      event: BDTO.TherapistEventType.consult,
    },
    {
      query: {
        enabled: !!date,
        keepPreviousData: true,
      },
    }
  );

  const slotsGroups = groupBy(data?.slots, 'daytime');

  const slotsEntries = entries(slotsGroups);

  return !!date ? (
    <Fragment>
      <Loading loading={isFetching} />
      <Heading bold align="center">
        {t('forms.timeWithTimeZone', {
          timeZone: tz,
        })}
      </Heading>
      <Form.RadioToggle
        name="dateTime"
        spacing="none"
        validation={{ required: true }}
      >
        <Container cols={slotsEntries.length}>
          {slotsEntries.map(([title, slots]) => {
            return (
              <Column key={title}>
                <Cell>
                  <Title align="center">{title}</Title>
                </Cell>
                {slots.map(({ start, isBusy }) => {
                  return (
                    <Cell key={start}>
                      <Form.RadioToggle.Item
                        value={start}
                        active={!isBusy}
                        block
                      >
                        {format({
                          value: start,
                          format: 'LT',
                        })}
                      </Form.RadioToggle.Item>
                    </Cell>
                  );
                })}
              </Column>
            );
          })}
        </Container>
      </Form.RadioToggle>
    </Fragment>
  ) : null;
};
